export default "__VITE_ASSET__e0e150b8__"